// extracted by mini-css-extract-plugin
export default {"DescriptionItem":"Description_DescriptionItem__cYte7"};